export const primaryColor: string = '#95c11f';
export const primaryColorLight: string = '#dfedbc';
export const secondaryColor: string = '#4F4F4F';
export const primaryTextColor: string = '#7da50b';
export const borderColor: string = '#dadada';
export const backgroundDefault: string = '#ffffff';
export const backgroundHover: string = '#ececec';

export const MediaQuerySmallPortrait: string = '@media screen and (max-width: 920px) and (max-height: 920px) and (orientation: portrait)';
export const MediaQueryDesktop: string = '@media screen and (min-width: 1025px)';

export const sidebarWidth: number = 47;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/layout/BaseLayout.ts